import styled from "styled-components";
import PageTitle from "./PageTitle";
import PageHeaderButton from "./Buttons/PageHeaderButton";

const PageHeader = ({
  pageTitle,
  subText,
  isButtoned = false,
  buttonText,
  buttonOnClick,
  buttonIcon,
  isButtonDisabled,
}: any) => {
  return (
    <Header>
      <TextWrapper>
        <PageTitle title={pageTitle} />
        {subText && <TitleSubText>{subText}</TitleSubText>}
      </TextWrapper>
      {isButtoned && (
        <PageHeaderButton
          icon={buttonIcon}
          title={buttonText}
          onClick={buttonOnClick}
          disabled={isButtonDisabled}
        />
      )}
    </Header>
  );
};

export default PageHeader;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
  min-height: 44px; //header button width
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TitleSubText = styled.div`
  color: #a3a3a3;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
`;
